import { createContext } from "react";

let CreateModalContext = createContext()

export default CreateModalContext